import React, { Component } from "react";
import { ReviewResource } from "../../../../stores/ReviewsStore/Types";
import ReviewModal from "./ReviewModal";

interface Props {
  review: ReviewResource;
}

interface State {
  showModal: boolean;
}

class Review extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickShowModal = (e, val) => {
    e.preventDefault();
    this.setState({ showModal: val });
  };

  render() {
    const { review } = this.props;

    const { showModal } = this.state;

    return (
      <>
        <article className="test-card" role="listitem">
          <div className="stars" aria-label="5 out of 5 stars">
            {"★".repeat(review.rating)}
            {"☆".repeat(5 - review.rating)}
          </div>
          <div className="quote-wrap">
            {review.content.slice(0, 130)}{" "}
            {review.content.length > 130 && (
              <a
                onClick={(e) => this.onClickShowModal(e, true)}
                href="#"
                style={{ textDecoration: "underline" }}
              >
                <strong>...more</strong>
              </a>
            )}
          </div>
          <div className="author-row">
            <div className="author-pic">
              <img className="profile-picture" src={review.profile_picture} />
            </div>
            <div className="author-meta">
              <div className="author-name">{review.user_name}</div>
              <div className="course-tag">
                <span className="sr-only">Course reviewed: </span>
                {review.course_name}
              </div>
            </div>
          </div>
        </article>
        <ReviewModal
          showModal={showModal}
          onClickShowModal={this.onClickShowModal}
          review={review}
        />
      </>
    );
  }
}

export default Review;
